import {
    Icon,
    Typography,
} from '@saddlebackchurch/react-cm-ui';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import classNames from 'classnames';
import React from 'react';
import {
    DEFAULT_LOAD_ERROR_SUBTITLE,
    DEFAULT_LOAD_ERROR_TITLE,
} from '../js/constants';

const BEM_BLOCK_NAME = 'hc_giving_load_error';

type PropTypes = {
    subtitle?: string;
    title?: string;
};

const defaultProps: Pick<PropTypes, 'subtitle' | 'title'> = {
    subtitle: DEFAULT_LOAD_ERROR_SUBTITLE,
    title: DEFAULT_LOAD_ERROR_TITLE,
};

const useStyles = makeStyles(({
    palette,
    spacing,
}) => ({
    errorContainer: {
        alignItems: 'center',
        backgroundColor: palette.background.secondary,
        border: `1px solid ${palette.grey[400]}`,
        borderRadius: 5,
        marginBottom: spacing(2),
        padding: spacing(1),
        textAlign: 'center',
    },
}));

function LoadError({
    subtitle,
    title,
}: PropTypes) {
    const classes = useStyles();

    return (
        <div
            className={classNames(
                classes.errorContainer,
                `${BEM_BLOCK_NAME}--container`,
            )}
        >
            <Icon
                className={`${BEM_BLOCK_NAME}--icon`}
                color="static"
                size={16}
                title={false}
                type="exclamation"
            />

            <Typography
                className={`${BEM_BLOCK_NAME}--title`}
                component="div"
                variant="h2"
            >
                {title}
            </Typography>

            <Typography
                className={`${BEM_BLOCK_NAME}--subtitle`}
                component="div"
                variant="body1"
            >
                {subtitle}
            </Typography>
        </div>
    );
}

LoadError.defaultProps = defaultProps;

export default LoadError;
